import { CreateVariantChildFormValues } from "./types";
import { defaultFormValues, schema } from "./constants";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface CreateVariantChildFormProviderProps {
  defaultValues?: Partial<CreateVariantChildFormValues>;
  children?: React.ReactNode;
}

export const CreateVariantChildFormProvider = ({
  defaultValues,
  children,
}: CreateVariantChildFormProviderProps) => {
  const normalizedDefaultValues: Partial<CreateVariantChildFormValues> =
    React.useMemo(() => {
      return {
        ...defaultFormValues,
        ...defaultValues,
      };
    }, []);

  const methods = useForm<CreateVariantChildFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: normalizedDefaultValues,
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
